import { buildColorPropsSDKFactoryCreator } from './colorPropsSDKFactoryBuilder';
export const createStrokeColorPropsSDKFactory = buildColorPropsSDKFactoryCreator('strokeColor');
//# sourceMappingURL=strokeColorPropsSDKFactory.js.map